import { useEffect } from "react";
import { useNavigate } from "react-router";

import { TerraformProviderWithVersions } from "./types";

const LATEST_KEY = "latest";

type VersionResolver = {
  versionNumber: string;
};

const useProviderVersionResolver = (
  versionParam: string | undefined,
  provider: TerraformProviderWithVersions
): VersionResolver => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!versionParam) {
      navigate(`/provider/${provider.id}`, { replace: true });
    }

    if (versionParam === LATEST_KEY && !provider.latestVersionNumber) {
      navigate(`/provider/${provider.id}`, { replace: true });
    }
  }, [versionParam, provider, navigate]);

  if (versionParam === LATEST_KEY) {
    const latestVersionNumber = provider.latestVersionNumber;
    if (latestVersionNumber) {
      return { versionNumber: latestVersionNumber };
    } else {
      return { versionNumber: versionParam };
    }
  }

  return { versionNumber: versionParam ?? "" };
};

export default useProviderVersionResolver;
